import { client } from '../utils/api-client'
import {
  WishlistApiResponse,
  MergeWishlistRequest,
  MergeWishlistResponse,
} from '../types/wishlist'

/**
 * Get the authenticated user's complete wishlist with product details
 */
export async function getWishlist(): Promise<WishlistApiResponse> {
  return client('wishlist')
}

/**
 * Add a product to the user's wishlist
 * Idempotent - calling multiple times with same product won't create duplicates
 * @param productId - The product ID to add to wishlist
 */
export async function addToWishlist(
  productId: string,
): Promise<WishlistApiResponse> {
  const data = {
    productId,
  }

  return client('wishlist/items', {
    data,
    method: 'POST',
  })
}

/**
 * Remove a product from the user's wishlist
 * Idempotent - safe to call even if item doesn't exist
 * @param productId - The product ID to remove from wishlist
 */
export async function removeFromWishlist(
  productId: string,
): Promise<WishlistApiResponse> {
  return client(`wishlist/items/${productId}`, {
    method: 'DELETE',
  })
}

/**
 * Merge guest wishlist (from localStorage) into authenticated user's wishlist on login
 * Handles duplicates automatically
 * @param productIds - Array of product IDs from guest wishlist
 */
export async function mergeWishlist(
  productIds: string[],
): Promise<MergeWishlistResponse> {
  const data: MergeWishlistRequest = {
    productIds,
  }

  return client('wishlist/merge', {
    data,
    method: 'POST',
  })
}

